import React, { forwardRef } from 'react';
import { isFieldValueEmpty, } from '@sitecore-jss/sitecore-jss/layout';
/**
 * Returns the passed field component or default component in case field value is empty and edit mode is 'metadata'
 * @param {ComponentType<FieldComponentProps>} FieldComponent the field component
 * @param {WithEmptyFieldEditingComponentProps} options the options of the HOC;
 */
export function withEmptyFieldEditingComponent(FieldComponent, options) {
    const getEmptyFieldEditingComponent = (props) => {
        var _a;
        const { editable = true } = props;
        if (((_a = props.field) === null || _a === void 0 ? void 0 : _a.metadata) && editable && isFieldValueEmpty(props.field)) {
            return props.emptyFieldEditingComponent || options.defaultEmptyFieldEditingComponent;
        }
        return null;
    };
    if (options.isForwardRef) {
        // eslint-disable-next-line react/display-name
        return forwardRef((props, ref) => {
            const EmptyFieldEditingComponent = getEmptyFieldEditingComponent(props);
            return (React.createElement(React.Fragment, null, (EmptyFieldEditingComponent && React.createElement(EmptyFieldEditingComponent, null)) || (React.createElement(FieldComponent, Object.assign({}, props, { ref: ref })))));
        });
    }
    // eslint-disable-next-line react/display-name
    return (props) => {
        const EmptyFieldEditingComponent = getEmptyFieldEditingComponent(props);
        return (React.createElement(React.Fragment, null, (EmptyFieldEditingComponent && React.createElement(EmptyFieldEditingComponent, null)) || (React.createElement(FieldComponent, Object.assign({}, props)))));
    };
}
